// src/ApolloClient.js

import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const client = new ApolloClient({
  link: new HttpLink({
    uri: 'https://cms.shikshainitiative.org/graphql',
  }),
  cache: new InMemoryCache(),
});

export default client;
